<template>
  <div class="modify-invoice-modal">
    <el-dialog title="修改发票" v-model="showModal" @close="closeModal"
    :close-on-click-modal="false">
      <div class="refuse-reason">
        <img
          src="../../../assets/imgs/invoice-manage/icon-refuse.png"
          class="refuse-img"
        />
        <div class="refuse-text">驳回原因：{{ invoice.refuse_reason }}</div>
      </div>

      <!-- 开票金额 -->
      <div class="form-line">
        <div class="form-field single-item">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">开票金额：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                :value="(invoice.invoice_price / 100).toFixed(2)"
                class="invoice-price"
                disabled
                placeholder="请输入"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 发票类别 -->
      <div class="form-line">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">发票类别：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <el-radio-group v-model="formData.invoice_type">
                <el-radio :label="0">电子发票</el-radio>
                <!-- <el-radio :label="1">纸质发票（顺丰到付）</el-radio> -->
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>

      <!-- 收货人 -->
      <div class="form-line" v-if="formData.invoice_type === 1">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">收货人：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                name="expressAddressee"
                maxlength="15"
                v-model="formData.express.addressee"
                @input="onFieldBlur"
                class="express-addressee"
                placeholder="请输入收货人"
                :class="{ error: formDataError.express.addressee.required }"
              />
            </div>
            <div
              class="err-tips"
              v-if="formDataError.express.addressee.required"
            >
              请输入收货人
            </div>
          </div>
        </div>
      </div>

      <!-- 联系电话 -->
      <div class="form-line" v-if="formData.invoice_type === 1">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">联系电话：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                name="mobilePhone"
                maxlength="11"
                v-model="formData.express.mobile_phone"
                @input="onFieldBlur"
                class="mobile-phone"
                placeholder="请输入联系电话"
                :class="{
                  error:
                    formDataError.express.mobile_phone.required ||
                    formDataError.express.mobile_phone.pattern
                }"
              />
            </div>
            <div
              class="err-tips"
              v-if="formDataError.express.mobile_phone.required"
            >
              请输入联系电话
            </div>
            <div
              class="err-tips"
              v-if="formDataError.express.mobile_phone.pattern"
            >
              请输入正确的手机号码
            </div>
          </div>
        </div>
      </div>

      <!-- 收货地址 -->
      <div class="form-line address-form-line" v-if="formData.invoice_type === 1">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">收货地址：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <el-select
                v-model="formData.express.province_code"
                placeholder="省"
                name="provinceCode"
                @change="
                  formData.express.city_code = '';
                  formData.express.county_code = '';
                  onFieldBlur();
                "
                :class="{ error: formDataError.express.province_code.required }"
              >
                <el-option
                  :label="province"
                  :value="parseInt(index)"
                  v-for="(province, index) in pcds[86]"
                  :key="index"
                ></el-option>
              </el-select>

              <el-select
                v-model="formData.express.city_code"
                name="cityCode"
                placeholder="市"
                @change="formData.express.county_code = ''; onFieldBlur();"
                :class="{ error: formDataError.express.city_code.required }"
              >
                <el-option
                  :label="city"
                  :value="parseInt(index)"
                  v-for="(city, index) in pcds[formData.express.province_code]"
                  :key="index"
                ></el-option>
              </el-select>

              <el-select
                v-model="formData.express.county_code"
                name="countyCode"
                placeholder="区"
                @change="onFieldBlur()"
                :class="{ error: formDataError.express.county_code.required }"
              >
                <el-option
                  :label="district"
                  :value="parseInt(index)"
                  v-for="(district, index) in pcds[formData.express.city_code]"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div
              class="err-tips"
              v-if="
                formDataError.express.province_code.required ||
                  formDataError.express.city_code.required ||
                  formDataError.express.county_code.required
              "
            >
              请选择收货地址
            </div>
          </div>
        </div>
      </div>

      <!-- 详细地址 -->
      <div class="form-line" v-if="formData.invoice_type === 1">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required"></div>
            <div class="label-text"></div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                name="detailAddress"
                maxlength="24"
                v-model="formData.express.detail_address"
                @input="onFieldBlur"
                class="detail-address"
                placeholder="请输入详细地址"
                :class="{
                  error: formDataError.express.detail_address.required
                }"
              />
            </div>
            <div
              class="err-tips"
              v-if="formDataError.express.detail_address.required"
            >
              请输入详细地址
            </div>
          </div>
        </div>
      </div>

      <!-- 抬头类型 -->
      <div class="form-line">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">抬头类型：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <el-radio-group name="headerType" v-model="formData.header_type">
                <el-radio :label="0">企业</el-radio>
                <el-radio :label="1">个人</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>

      <!-- 发票抬头-->
      <div class="form-line">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">发票抬头：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                class="invoce-header"
                name="invoiceHeader"
                maxlength="100"
                v-model="formData.invoice_header"
                @input="onFieldBlur"
                placeholder="请输入发票抬头"
                :class="{ error: formDataError.invoice_header.required }"
              />
            </div>
            <div class="err-tips" v-if="formDataError.invoice_header.required">
              请输入发票抬头
            </div>
          </div>
        </div>
      </div>

      <!-- 公司税号 -->
      <div class="form-line" v-if="formData.header_type === 0">
        <div class="form-field">
          <div class="field-label">
            <div class="field-required">*</div>
            <div class="label-text">公司税号：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                name="taxerIdNum"
                maxlength="18"
                v-model="formData.taxer_id_num"
                class="taxer-id-num"
                placeholder="请输入纳税人识别号"
                @input="onFieldBlur"
                :class="{
                  error:
                    formDataError.taxer_id_num.required ||
                    formDataError.taxer_id_num.pattern
                }"
              />
            </div>
            <div class="err-tips" v-if="formDataError.taxer_id_num.required">
              请输入公司税号
            </div>
            <div class="err-tips" v-if="formDataError.taxer_id_num.pattern">
              请输入正确的公司税号，格式为字母+数字
            </div>
          </div>
        </div>
      </div>

      <!-- 备注信息 -->
      <div class="form-line">
        <div class="form-field">
          <div class="field-label">
            <div class="label-text">备注信息：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                name="memo"
                maxlength="50"
                v-model="formData.memo"
                class="peer-memo"
                placeholder="有特殊需求请备注"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 电子邮箱 -->
      <div class="form-line" v-if="formData.invoice_type === 0">
        <div class="form-field">
          <div class="field-label">
            <div class="label-text">电子邮箱：</div>
          </div>
          <div class="field-ctrl">
            <div class="ctrl-wrapper">
              <input
                type="text"
                class="email"
                name="email"
                maxlength="50"
                v-model="formData.email"
                @input="onFieldBlur"
                placeholder="请输入正确邮箱地址，用于接收发票"
                :class="{ error: formDataError.email.pattern }"
              />
            </div>
            <div class="err-tips" v-if="formDataError.email.pattern">
              请输入正确邮箱地址
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="ensure-btn" @click="updateInvoice"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import invoiceService from '../../../services/invoice-service';
import invoiceApi from '../../../api/invoice-api';
import utils from '../../../libs/utils';

export default {
  name: 'modify-invoice-modal',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: true,
    },
    invoice: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    pcds: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      invoiceDetail: {},
      showModal: true,
      formData: {
        invoice_price: '', // 开票金额
        invoice_type: 0, // 发票类型
        header_type: 0, // 抬头类型
        invoice_header: '', // 发票抬头
        taxer_id_num: '', // 纳税人识别好
        memo: '', // 备注
        email: '', // 邮箱
        express: {
          addressee: '', // 收货人
          mobile_phone: '', // 联系电话
          province_code: '', // 省
          city_code: '', // 市
          county_code: '', // 区
          detail_address: '', // 详细地址
        },
      },
      formSubmitted: false,
      formDataError: invoiceService.getFormDataError(),
    };
  },
  methods: {
    closeModal() {
      this.$emit('input', false);
    },

    // 在提交后才开启失焦优化
    onFieldBlur() {

      if (this.formSubmitted) {

        // 验证下面的表单
        const { newFormDataError } = invoiceService.validateFormData(
          false, this.formData, this.totalOrderPrice, this.pcds,
        );

        // 设置表单错误
        this.formDataError = newFormDataError;
      }
    },

    // 修改发票
    updateInvoice() {
      this.formSubmitted = true;

      // 验证下面的表单
      const { haveFieldError, newFormDataError } = invoiceService.validateFormData(
        false, this.formData, this.totalOrderPrice, this.pcds,
      );

      // 设置表单错误
      this.formDataError = newFormDataError;

      // 没有字段错误才继续
      if (!haveFieldError) {

        // 构建参数
        const params = invoiceService.createParams(
          this.invoice.id, this.formData, this.selectedOrders,
        );

        // 更新
        invoiceApi.invoiceUpdate(params).then(() => {
          utils.msg.success('更新成功！');
          this.$emit('updatedInvoice', this.invoice);
          this.closeModal();
        }).catch((err) => {
          console.log(err);
        });
      }
    },

    // 获取发票详情
    getInvoiceDetail() {
      invoiceApi.invoiceQuery({
        order_invoice_id: this.invoice.id,
      }).then((data) => {
        this.invoiceDetail = data;
        this.prefillFormData(data);
      });
    },

    // 填充字段内容
    prefillFormData(invoiceDetail) {
      this.formData = {
        invoice_price: invoiceDetail.invoice_price, // 开票金额
        invoice_type: invoiceDetail.invoice_type, // 发票类型
        header_type: invoiceDetail.header_type, // 抬头类型
        invoice_header: invoiceDetail.invoice_header, // 发票抬头
        taxer_id_num: invoiceDetail.taxer_id_num, // 纳税人识别好
        memo: invoiceDetail.memo, // 备注
        email: invoiceDetail.email, // 邮箱
        express: {
          addressee: invoiceDetail.express ? invoiceDetail.express.addressee : '', // 收货人
          mobile_phone: invoiceDetail.express ? invoiceDetail.express.mobile_phone : '', // 联系电话
          province_code: invoiceDetail.express ? invoiceDetail.express.province_code : '', // 省
          city_code: invoiceDetail.express ? invoiceDetail.express.city_code : '', // 市
          county_code: invoiceDetail.express ? invoiceDetail.express.county_code : '', // 区
          detail_address: invoiceDetail.express ? invoiceDetail.express.detail_address : '', // 详细地址
        },
      };
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
  created() {
    this.getInvoiceDetail();
  },
};
</script>

<style lang="less" scoped>
.modify-invoice-modal {
  /deep/ .el-dialog {
    width: 600px;
    .el-dialog__header {
      height: 60px;
      border-bottom: 1px solid #e9eef2;
    }
    .el-dialog__body {
      padding: 16px 24px;
    }
  }
  .refuse-reason {
    display: flex;
    align-items: center;
    background: #fff2f2;
    border-radius: 1px;
    padding: 7px 12px;
    margin-bottom: 16px;
    .refuse-img {
      width: 16px;
      height: 16px;
    }
    .refuse-text {
      font-size: 14px;
      font-weight: 400;
      color: #ff6464;
      line-height: 20px;
      margin-left: 8px;
    }
  }
  .form-line {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    .form-field {
      display: flex;
      align-items: center;
      flex: 1;
      & + .form-field {
        margin-left: 30px;
      }
      &.single-item {
        flex: none;
        width: 300px;
      }
      .field-label {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        line-height: 16px;
        width: 83px;
        flex-shrink: 0;
        .field-required {
          color: #f4455c;
          margin-right: 3px;
        }
        .label-text {
          color: #2f333d;
        }
      }
      .field-ctrl {
        display: flex;
        align-items: center;
        flex: 1;
        position: relative;
        height: 40px;
        .ctrl-wrapper {
          display: flex;
          align-items: center;
          position: relative;
          flex: 1;
          input {
            width: 50%;
            padding: 0 12px;
            height: 40px;
            border-radius: 2px;
            border: 1px solid #dee2e6;
            color: #2F333D;
            flex: 1;
            font-size: 14px;
            outline: 0;
            &:focus {
              border: 1px solid #599FFF;
            }
            &.error {
              border-color: #ff6464;
            }
          }
          /deep/ .el-select {
            margin-right: 12px;
            &:last-child {
              margin-right: 0;
            }
            &.error {
              input {
                border-color: #ff6464;
              }
            }
          }
          .input-tips {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 12px;
            font-size: 14px;
            font-weight: 400;
            color: #c9cdd1;
            line-height: 14px;
          }
        }
        .err-tips {
          display: flex;
          position: absolute;
          left: 12px;
          bottom: -20px;
          font-size: 12px;
          font-weight: 400;
          color: #5f666e;
          line-height: 12px;
          color: #f4455c;
        }
      }
    }
    &.address-form-line {
      margin-bottom: 16px;
    }
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #e9eef2;
    padding: 16px 24px;
    .dialog-footer {
      .ensure-btn {
        height: 48px;
        background: #599FFF;
        border-radius: 4px;
        width: 116px;
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/components/modify-invoice-modal.vue